import { useMemo } from 'react';

import styles from './multicolor-bar.module.scss';

export const MultiColorBar = ({
  segments,
}: {
  segments: {
    value: number | undefined;
    color: string;
  }[];
}) => {
  const total = useMemo(
    () => segments.reduce((acc, item) => acc + (item.value || 0), 0),
    [segments]
  );

  if (!total) return;

  return (
    <div className={styles['multicolor-bar']}>
      {segments.map((segment, idx) => (
        <div
          key={idx}
          style={{
            width: `${((segment.value || 0) / (total || 1)) * 100}%`,
            backgroundColor: segment.color,
          }}
        />
      ))}
    </div>
  );
};
